<template>
  <div>
    <Page :selectedPageTemplate="selectedPageTemplate" />
  </div>
</template>

<script>
export default {
  components: {
    Page: () => import("@/components/Design/View/ViewTheme")
  },
  data: () => ({
    selectedPageTemplate: "Basic Page"
  }),
  computed: {
    pageId() {
      return this.$route.params.id;
    },
    currentUser() {
      return this.$store.getters.currentUser;
    },
    // Get page data from menu items
    pageData() {
      const primaryMenus =
        this.$store.state.progress && this.$store.state.progress.primaryMenus
          ? this.$store.state.progress.primaryMenus
          : [];
      const secondaryMenus =
        this.$store.state.progress && this.$store.state.progress.secondaryMenus
          ? this.$store.state.progress.secondaryMenus
          : [];
      const allMenus = [...primaryMenus, ...secondaryMenus];

      // Find menu item where contentType is 'Custom Page' and content matches pageId
      const menuItem = allMenus.find(
        menu =>
          menu.contentType === "Custom Page" && menu.content === this.pageId
      );

      return menuItem && menuItem.pageData ? menuItem.pageData : null;
    },
    // Get template from page's templateId
    pageTemplate() {
      if (!this.pageData || !this.pageData.templateId) {
        return "Basic Page";
      }

      const templateId = this.pageData.templateId;
      
      // Default template
      if (templateId === "default") {
        return "Basic Page";
      }

      // Get webTheme from store to resolve template name
      const webTheme = this.$store.getters.currentProgram?.webTheme;
      if (!webTheme || !webTheme.content || !webTheme.content.pages) {
        return "Basic Page";
      }

      // Handle array structure (new multi-template system)
      if (Array.isArray(webTheme.content.pages)) {
        const template = webTheme.content.pages.find(
          page => page.id === templateId
        );
        return template ? template.name : "Basic Page";
      }

      return "Basic Page";
    }
  },
  watch: {
    pageTemplate: {
      immediate: true,
      handler(template) {
        this.selectedPageTemplate = template;
      }
    },
    pageId: {
      immediate: true,
      handler() {
        // Update template when page changes
        this.selectedPageTemplate = this.pageTemplate;
      }
    }
  },
  created() {
    // Ensure menus are loaded with safe null checks
    if (this.currentUser) {
      if (
        !this.$store.state.progress ||
        !this.$store.state.progress.primaryMenus ||
        this.$store.state.progress.primaryMenus.length === 0
      ) {
        this.$store.dispatch("getPrimaryMenus", this.currentUser);
      }
      if (
        !this.$store.state.progress ||
        !this.$store.state.progress.secondaryMenus ||
        this.$store.state.progress.secondaryMenus.length === 0
      ) {
        this.$store.dispatch("getSecondaryMenus", this.currentUser);
      }
    }
  }
};
</script>
